import React from 'react'
import { Box } from 'components/layout/Box/Box'
import cx from 'classnames'
import styles from './DoubleEndedScale.module.scss'
import { Arrow } from 'components/shared/Arrow/Arrow'
import { Scale } from './Scale'
import { t } from 'ttag'
import {
  ChevronDownIcon,
  ChevronRightIcon,
  Icon,
} from 'components/shared/Icon/Icon'
import { prepText } from 'components/modals/TestsReportModal/tabs/helpers'

export const LabeledScale = ({
  lowLabel,
  highLabel,
  scores,
  single,
  selectedCandidates,
  selectable,
}) => (
  <div
    className={cx(styles.scaledLabel, {
      [styles.selectable]: selectable,
    })}
  >
    <div
      className={cx(styles.label, styles.leftLabel, {
        [styles.highlight]: single && scores[0].score < 35,
      })}
    >
      {lowLabel}
    </div>
    <Scale
      scores={scores}
      single={single}
      selectedCandidates={selectedCandidates}
    />
    <div
      className={cx(styles.label, styles.rightLabel, {
        [styles.highlight]: single && scores[0].score > 66,
      })}
    >
      {highLabel}
    </div>
  </div>
)

export const TooltipContent = ({
  score,
  hasArrow,
  floating,
  floatingStyle,
  arrowRef,
  arrowStyle,
  label,
  abstract,
  low,
  mid,
  high,
}) => {
  return (
    <Box
      align="center"
      className={styles.message}
      justify="center"
      ref={floating}
      role="status"
      style={floatingStyle}
    >
      {hasArrow && (
        <Arrow ref={arrowRef} size="small" style={arrowStyle} theme="bright" />
      )}
      <Box
        align="center"
        className={styles.content}
        direction="column"
        justify="center"
        role="tooltip"
      >
        <div>
          <p>
            <span>{label} </span>
            {prepText(label)((abstract ?? '').replace('{Trait}', ''))}
          </p>
        </div>
        <div>
          <p>
            {prepText(label)(
              [low, mid, high][Math.min(Math.floor(score.score / 33.3), 2)],
            )}
          </p>
        </div>
      </Box>
    </Box>
  )
}

export const DoubleEndedScale = ({
  abstract,
  high,
  mid,
  low,
  scores,
  lowLabel,
  highLabel,
  label,
  onClick,
  selectable,
  selected,
  expandable,
  isColoredBackground,
  single,
  isOpen,
  setIsOpen,
  selectedCandidates,
}) => {
  return (
    <>
      <Box
        className={cx(styles.doubleEndedScale, {
          [styles.selectable]: !!selectable,
          [styles.selected]: !!selected,
          [styles.isOpen]: isOpen,
          [styles.expandable]: expandable,
          [styles.single]: single,
        })}
        align="center"
        onClick={onClick}
      >
        <div
          className={cx(styles.title, {
            [styles.selected]: !!selected,
            [styles.coloredBackground]: isColoredBackground,
          })}
        >
          {label}
        </div>
        <div
          className={cx(styles.description, {
            [styles.isOpen]: isOpen,
            [styles.single]: single,
          })}
        >
          <div>
            <span>{label} </span>
            <span>
              {prepText(label)((abstract ?? '').replace('{Trait}', ''))}{' '}
            </span>
            {single ? (
              <span>
                {prepText(label)(
                  [low, mid, high][
                    Math.min(Math.floor(scores[0].score / 33.3), 2)
                  ],
                )}
              </span>
            ) : null}
          </div>
        </div>
        <LabeledScale
          {...{
            lowLabel,
            highLabel,
            scores,
            single,
            selectedCandidates,
            selectable,
          }}
        />
        {selectable ? (
          <div className={cx(styles.viewMore, { [styles.selected]: selected })}>
            {t`View more`}{' '}
            <Icon className={styles.icon} icon={ChevronRightIcon} />
          </div>
        ) : null}
        {expandable ? (
          <div
            className={cx(styles.expander, { [styles.isOpen]: isOpen })}
            onClick={() => setIsOpen(!isOpen)}
          >
            <Icon className={styles.icon} icon={ChevronDownIcon} size="24" />
          </div>
        ) : null}
      </Box>
    </>
  )
}
